import styled from 'styled-components';
import {Typography} from '@/components/Typography';
import {palette} from '@/styles';
import Icon from './assets/warning.svg';

export const ErrorItem = ({onRetry}: {onRetry: () => void}) => (
  <ErrorBox>
    <ErrorLogoTextBox>
      <img src={Icon} width={64} height={64} alt={'warning'} />
      <Typography variant="bold16" color={palette.gray800} align="center">
        일시적인 오류가 발생했습니다.
      </Typography>
      <Typography variant="medium14" color={palette.gray600} align="center">
        잠시 후 다시 시도해주세요.
        <br />
        문제가 지속될 경우, 고객센터로 문의해 주세요.
      </Typography>
    </ErrorLogoTextBox>
    <RetryButton onClick={onRetry}>
      <Typography variant="bold14" color={palette.white}>
        다시 시도
      </Typography>
    </RetryButton>
  </ErrorBox>
);

const ErrorBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  background-color: ${palette.white};
  align-items: center;
  justify-content: center;
`;

const ErrorLogoTextBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: center;
  justify-content: center;
`;

const RetryButton = styled.div`
  display: flex;
  flex-direction: row;
  padding: 7px 12px;
  background-color: ${palette.gray800};
  border-radius: 5px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
